export function languageToDefaultCountry(language: string): string {
    const languageToCountryMap = {
        de: 'de',
        en: 'us',
        es: 'es',
        fr: 'fr',
        id: 'id',
        it: 'it',
        ja: 'jp',
        ko: 'kr',
        nl: 'nl',
        pl: 'pl',
        pt: 'br',
        ro: 'ro',
        ru: 'ru',
        th: 'th',
        tr: 'tr',
        zh: 'cn',
    };
    return languageToCountryMap[language as keyof typeof languageToCountryMap];
}
